import querystring from 'querystring';

const SPO_IMPRESSION_URL = `${process.env.AWS_API_HOST}/spo/v2/attribution/impression`;
export const API_KEY = 'cPgSLJL58xJzCsQvy7BiC9kshJDCZKpp';

export const getSpoImpressionUrl = (adDecisionId, adDecisionToken, directoryId) => {
    const queryParams = {
        apikey: API_KEY,
        ad_decision_id: adDecisionId,
        decision_token: adDecisionToken,
        directory_id: directoryId,
    };

    return `${SPO_IMPRESSION_URL}?${querystring.stringify(queryParams)}`;
};

// Get the query params we need to append to the profile and booking urls in the search results
export const getSpoQueryParamsFromProviderLocationResult = providerSearchResult => {
    return providerSearchResult.isSponsoredResult ? {
        // Yes, the casing/naming on these params are weird as heck
        spoAdDecisionId: providerSearchResult.sponsoredData.adDecisionId,
        ad_decision_token: providerSearchResult.sponsoredData.adDecisionToken,
    } : {};
};
